export const BLOG_SETTINGS_ID = '^blog-settings/v1/blogs(/[0-9]+)?$';
export const CTAS_PLACEMENTS_ID = '^ctas/v3/placements(/[0-9]+)?$';
export const COSEMAIL_EMAILS_ID = '^cosemail/v1/emails(/[0-9]+)?$';
export const FORMS_ID = '^forms/v2/forms(/[0-9]+)?$';
export const FORMS_COUNT = '^forms/v2/forms/count$';
export const CONTENT_LINKABLE_PAGES = '^content/api/v4/contents/linkable-pages(/[0-9]+)?$';
export const MEETINGS_LINK_V1 = '^meetings/v1/link/slug(/[0-9]+)?$';
export const MEETINGS_LINK_V2 = '^meetings/v2/link/slug(/[0-9]+)?$';
export const MEETINGS_LINK_PORTAL_V1 = '^meetings/v1/link/portal$';
export const MEETINGS_LINK_PORTAL_V2 = '^meetings/v2/link/portal$';
export const WEBINAR_SETTINGS = '^gotowebinar/v1/settings$';
export const FORMS_GOTOWEBINAR_ELIGIBLE = '^forms/v2/forms/gotowebinar-eligible$';
export const FORMS_GOTOWEBINAR_FUTURE = '^gotowebinar/v1/webinars/future\\?includeOnDemand=true$';
export const HUBDB_TABLES = '^hubdb/api/v2/tables(/[0-9]+)?$';
export const CONTENT_ICONS_V1 = '^content-icons/v1$';
export const CMS_ADVANCED_MENUS = '^cms/v3/menus(/[0-9]+)?$';
export const SFDC_INTEGRATION_STATUS = '^sfdc/v1/integration-status$';
export const SFDC_V1_CAMPAIGNS = '^sfdc/v1/campaigns(/[0-9]+)?$';
export const CONTENT_SETTINGS_V1_SITE_SETTINGS_BY_PORTAL_ID = '^content-settings/v1/site-settings/by-portal-id(/[0-9]+)?$';
export const APP_USERS_V1_TEAMS_HIERARCHY = '^app-users/v1/teams/hierarchy$';
export const USERS_V2_APP_HUB_USERS = '^users/v2/app/hub-users$';
export const AUTOMATION_V3_WORKFLOWS = '^automation/v3/workflows$';
export const BLOGS_V3_TAGS = '^blogs/v3/tags(/[0-9]+)?$';
export const BLOGS_V3_TAGS_SEARCH = '^blogs/v3/tags/search$';
export const FILEMANAGER_VIDEO_FILE_METADATA = '^filemanager/api/v3/players/([0-9]+)/videos/file-metadata$';
export const RSSFEEDS_VALIDATE = '^cosemail/v1/rssfeeds/validate$';
export const FEEDBACK_SURVEY_PAGE = '^feedback/v1/survey/page$';
export const FEEDBACK_NPS_CES_CSAT = '^feedback/v1/(nps|ces|csat)/([0-9]{1,10})$';
export const FEEDBACK_NPS_CES_CSAT_ENABLE_DISABLE = '^feedback/v1/(nps|ces|csat)/(enable|disable)/([0-9]+)$';
export const INBOUNDDB_OBJECTS_V1_CRM_OBJECTS = '^inbounddb-objects/v1/crm-objects$';
export const CRM_OBJECT_SCHEMAS_V3_SCHEMAS = '^crm-object-schemas/v3/schemas$';
export const CRM_SEARCH_SEARCH = '^crm-search/v1/search$';
export const INBOUNDDB_META_V1_OBJECT_TYPES_FOR_PORTAL = '^inbounddb-meta/v1/object-types/for-portal$';
export const EXTENSIONS_ECOMM_V2_UI_STORES = '^extensions/ecomm/v2/ui/stores$';
/**
 * @deprecated - use SEARCH_EXTERNAL_SYNC_SOURCES_WITH_PRODUCTS_INBOUNDDBPRODUCTS instead
 */
export const SEARCH_EXTERNAL_SYNC_SOURCES_WITH_PRODUCTS_FOLDERS = '^folders/v1/search/external-sync-sources-with-products$';
export const SEARCH_EXTERNAL_SYNC_SOURCES_WITH_PRODUCTS_INBOUNDDBPRODUCTS = '^inbounddbproducts/v1/external-sync/external-sync-sources-with-products$';
export const OEMBEDPROXY_OEMBED = '^oembedproxy/v1/oembed$';
export const OEMBEDPROXY_APP_OEMBED = '^oembedproxy/v1/app-oembed$';
export const MEDIA_BRIDGE_PROVIDERS = '^media-bridge/v1/providers$';
export const COS_RENDERING_INTERNAL_RENDER_SECTION = '^cos-rendering/v1/internal/render/section$';
const apiProxyList = [{
  regex: new RegExp(BLOG_SETTINGS_ID),
  methods: ['GET']
}, {
  regex: new RegExp(CTAS_PLACEMENTS_ID),
  methods: ['GET']
}, {
  regex: new RegExp(COSEMAIL_EMAILS_ID),
  methods: ['GET']
}, {
  regex: new RegExp(FORMS_ID),
  methods: ['GET', 'POST']
}, {
  regex: new RegExp(FORMS_COUNT),
  methods: ['GET']
}, {
  regex: new RegExp(CONTENT_LINKABLE_PAGES),
  methods: ['GET']
}, {
  regex: new RegExp(MEETINGS_LINK_V1),
  methods: ['GET']
}, {
  regex: new RegExp(MEETINGS_LINK_V2),
  methods: ['GET']
}, {
  regex: new RegExp(MEETINGS_LINK_PORTAL_V1),
  methods: ['GET']
}, {
  regex: new RegExp(MEETINGS_LINK_PORTAL_V2),
  methods: ['GET']
}, {
  regex: new RegExp(WEBINAR_SETTINGS),
  methods: ['GET']
}, {
  regex: new RegExp(FORMS_GOTOWEBINAR_ELIGIBLE),
  methods: ['GET']
}, {
  regex: new RegExp(FORMS_GOTOWEBINAR_FUTURE),
  methods: ['GET']
}, {
  regex: new RegExp(HUBDB_TABLES),
  methods: ['GET']
}, {
  regex: new RegExp(CONTENT_ICONS_V1),
  methods: ['GET']
}, {
  regex: new RegExp(CMS_ADVANCED_MENUS),
  methods: ['GET', 'POST']
}, {
  regex: new RegExp(SFDC_INTEGRATION_STATUS),
  methods: ['GET']
}, {
  regex: new RegExp(SFDC_V1_CAMPAIGNS),
  methods: ['GET']
}, {
  regex: new RegExp(CONTENT_SETTINGS_V1_SITE_SETTINGS_BY_PORTAL_ID),
  methods: ['GET']
}, {
  regex: new RegExp(APP_USERS_V1_TEAMS_HIERARCHY),
  methods: ['GET']
}, {
  regex: new RegExp(USERS_V2_APP_HUB_USERS),
  methods: ['GET']
}, {
  regex: new RegExp(AUTOMATION_V3_WORKFLOWS),
  methods: ['GET']
}, {
  regex: new RegExp(BLOGS_V3_TAGS),
  methods: ['GET']
}, {
  regex: new RegExp(BLOGS_V3_TAGS_SEARCH),
  methods: ['GET']
}, {
  regex: new RegExp(FILEMANAGER_VIDEO_FILE_METADATA),
  methods: ['GET']
}, {
  regex: new RegExp(RSSFEEDS_VALIDATE),
  methods: ['GET']
}, {
  regex: new RegExp(FEEDBACK_SURVEY_PAGE),
  methods: ['GET']
}, {
  regex: new RegExp(FEEDBACK_NPS_CES_CSAT),
  methods: ['GET']
}, {
  regex: new RegExp(FEEDBACK_NPS_CES_CSAT_ENABLE_DISABLE),
  methods: ['PUT']
}, {
  regex: new RegExp(INBOUNDDB_OBJECTS_V1_CRM_OBJECTS),
  methods: ['GET']
}, {
  regex: new RegExp(CRM_OBJECT_SCHEMAS_V3_SCHEMAS),
  methods: ['GET']
}, {
  regex: new RegExp(CRM_SEARCH_SEARCH),
  methods: ['POST']
}, {
  regex: new RegExp(INBOUNDDB_META_V1_OBJECT_TYPES_FOR_PORTAL),
  methods: ['GET']
}, {
  regex: new RegExp(EXTENSIONS_ECOMM_V2_UI_STORES),
  methods: ['GET']
},
/**
 * @deprecated - use SEARCH_EXTERNAL_SYNC_SOURCES_WITH_PRODUCTS_INBOUNDDBPRODUCTS instead
 */
{
  regex: new RegExp(SEARCH_EXTERNAL_SYNC_SOURCES_WITH_PRODUCTS_FOLDERS),
  methods: ['GET']
}, {
  regex: new RegExp(SEARCH_EXTERNAL_SYNC_SOURCES_WITH_PRODUCTS_INBOUNDDBPRODUCTS),
  methods: ['GET']
}, {
  regex: new RegExp(OEMBEDPROXY_OEMBED),
  methods: ['GET']
}, {
  regex: new RegExp(OEMBEDPROXY_APP_OEMBED),
  methods: ['GET']
}, {
  regex: new RegExp(MEDIA_BRIDGE_PROVIDERS),
  methods: ['GET', 'POST']
}, {
  regex: new RegExp(COS_RENDERING_INTERNAL_RENDER_SECTION),
  methods: ['POST']
}];
export default apiProxyList;